import { spacingFluidMd, spacingFluidXl } from "@porsche-design-system/components-react/emotion"
import { Grid, GridItem, Skeleton } from "src/components"

export const TechnicalDataSkeleton = () => (
	<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }}>
		<GridItem size={{ base: 12, m: 6 }}>
			<Skeleton.Accordion />
			<Skeleton.Accordion />
			<Skeleton.Accordion />
			<Skeleton.Accordion />
		</GridItem>
	</Grid>
)
